const ConfigurationTag = class ConfigurationTag {
    get = type => {
        switch (type) {
            case 0:
                return this._createTag('Complete', type);
            case 1:
                return this._createTag('In progress', type);
            case 2:
                return this._createTag('Invalid', type);

        }
    }

    _createTag = (name, type) => {
        return (
            <div className={`configuration-tag configuration-tag-${type}`}>
                {__(name)}
            </div>
        )
    }
}

export default new ConfigurationTag()